module.exports = __webpack_public_path__ + "static/img/off.1a6b4473.png";